import { Backdrop } from "@mui/material";
import React from "react";
import "./styles.css";

const GlobalLoader = ({ open }) => {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <div class="wrapper">
        <div class="loader">
          <span class="pip-0"></span>
          <span class="pip-1"></span>
          <span class="pip-2"></span>
          <span class="pip-3"></span>
          <span class="pip-4"></span>
          <span class="pip-5"></span>
        </div>
      </div>
    </Backdrop>
  );
};

export default GlobalLoader;
